export const EmptyState = () => (
  <div className="flex flex-col items-center justify-center h-full py-20 gap-2 text-center">
    <p className="text-ui-text3 text-sm font-medium">Ask SAM something to get started</p>
    <p className="text-ui-text2 text-xs">e.g. &ldquo;list today&apos;s tasks&rdquo;, &ldquo;show active properties&rdquo;, &ldquo;my meetings this week&rdquo;</p>
  </div>
);

export default EmptyState;
